import { atom } from 'recoil';
import { EventoAtualPlataforma } from 'types/eventoAtualPlataforma';

const PREFIX_KEY = 'src/atoms/eventoAtualPlataforma/';

export const eventoAtualPlataformaAtom = atom<EventoAtualPlataforma | null>({
  key: `${PREFIX_KEY}eventoAtualPlataforma.atom`,
  default: null,
});
